import _defineProperty from "@babel/runtime/helpers/defineProperty";
import IMask from 'imask';
class CustomDateMask extends IMask.MaskedDate {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "queue", '');
  }
  // eslint-disable-next-line no-underscore-dangle
  _appendChar(char, flags, checkTail) {
    // eslint-disable-next-line no-underscore-dangle
    const details = super._appendChar(char, flags, checkTail);
    for (let queueIndex = 0; queueIndex < Math.min(10, this.queue.length); queueIndex += 1) {
      details.aggregate(
      // eslint-disable-next-line no-underscore-dangle
      super._appendChar(this.queue[queueIndex], flags, checkTail));
    }
    this.queue = '';
    return details;
  }
}
export default CustomDateMask;